export const ADD_COMMENT = "ADD_COMMENT";
export const SET_COMMENTS = "SET_COMMENTS";
export const SET_COMMENTS_LOADING = "SET_COMMENTS_LOADING";
export const SET_ITEM_ID_COMMENTS = "SET_ITEM_ID_COMMENTS";

export const DEFAULT_QUERY_PARAMS = { limit: 1000, ordering: "-created_at" };